import React from 'react';
import { getVCookie } from '@chegg/utils';
import DropInPaymentsWrapper from '../../../modules/DropInPayments';
import { DropInPaymentsOverlay, CenteredWrapper } from '../styled';
import { getPaymentMethodsHeadingText } from '../helpers';
import { LoadingIcon } from '@chegg-ui/theme';
var DropInPaymentsLayout = function DropInPaymentsLayout(_ref) {
  var _getVCookie;
  var authorization = _ref.authorization,
    country = _ref.country,
    withCoupon = _ref.withCoupon,
    namespace = _ref.namespace,
    externalId = _ref.externalId,
    userUuid = _ref.userUuid,
    environment = _ref.environment,
    action = _ref.action,
    optimizelyClient = _ref.optimizelyClient,
    referrer = _ref.referrer,
    useForter = _ref.useForter,
    taxInfo = _ref.taxInfo,
    coupon = _ref.coupon,
    orderSummary = _ref.orderSummary,
    paymentForm = _ref.paymentForm,
    paymentErrorModal = _ref.paymentErrorModal,
    paymentMethodsHeadingText = _ref.paymentMethodsHeadingText,
    isCTALoading = _ref.isCTALoading,
    reviewStepEnabled = _ref.reviewStepEnabled,
    dipCommands = _ref.dipCommands,
    isReviewStep = _ref.isReviewStep,
    venmoVisible = _ref.venmoVisible,
    googlepayVisible = _ref.googlepayVisible,
    couponCode = _ref.couponCode,
    recurlyCart = _ref.recurlyCart,
    isRecurly = _ref.isRecurly;
  /* istanbul ignore next */
  var uvn = (_getVCookie = getVCookie()) !== null && _getVCookie !== void 0 ? _getVCookie : ''; // only time it will be unavailable is in local development
  return /*#__PURE__*/React.createElement(DropInPaymentsOverlay, null, /*#__PURE__*/React.createElement(CenteredWrapper, {
    isCTALoading: isCTALoading
  }, /*#__PURE__*/React.createElement(LoadingIcon, {
    size: 'medium',
    "aria-live": "assertive",
    "aria-label": 'processing'
  })), /*#__PURE__*/React.createElement(DropInPaymentsWrapper, {
    country: country,
    authorization: authorization,
    withCoupon: !!withCoupon,
    content: {
      couponContent: coupon,
      orderSummaryContent: orderSummary
    },
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    commands: dipCommands,
    namespace: namespace,
    headingText: getPaymentMethodsHeadingText(isReviewStep, paymentMethodsHeadingText),
    showHeading: true,
    externalId: externalId,
    fireRioPurchaseEvent: false //@Douglass TODO:change to true once DDRW launches
    ,
    uvn: uvn,
    userUuid: userUuid,
    environment: environment,
    reviewStepEnabled: reviewStepEnabled,
    userAction: action,
    optimizelyClient: optimizelyClient,
    referrer: referrer,
    useForter: useForter,
    taxInfo: taxInfo,
    venmoVisible: venmoVisible,
    googlepayVisible: googlepayVisible,
    couponCode: couponCode,
    recurlyCart: recurlyCart,
    isRecurly: isRecurly
  }));
};
export default DropInPaymentsLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/DropInPaymentsLayout.js
// module id = 1469
// module chunks = 11